import axios from 'axios';

import { showToast } from '@/components/reusable/toast';

export const handleError = (error: unknown, callback?: () => void) => {
	callback?.();

	if (axios.isCancel(error)) {
		console.error('Request canceled', error.message);
		return;
	}

	let errorMessage = 'An unexpected error occurred';

	// Check if it's an error generated by Axios
	if (axios.isAxiosError(error)) {
		// Accessing error.response is now safe and typed
		const serverMessage = error.response?.data?.message;
		const status = error.response?.status;

		if (error.code === 'ECONNABORTED') {
			errorMessage = 'Request timed out. Please try again.';
		} else if (!error.response) {
			errorMessage = 'Network error: Unable to reach the server.';
		} else {
			errorMessage = serverMessage || `Error ${status}: ${error.message}`;
		}

		console.error('Axios Context:', error.config?.url, status);
	} else if (error instanceof Error) {
		// Handle standard JS errors (e.g., syntax or manual throws)
		errorMessage = error.message;
	}

	showToast('error', errorMessage);
};
